define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseJwtClaims = void 0;
    const isNonEmptyString = (v) => typeof v === "string" && v.trim().length > 0;
    const isValidJwtClaims = (claims) => isNonEmptyString(claims.sub) &&
        isNonEmptyString(claims.jti) &&
        typeof claims.exp === "number" &&
        Number.isFinite(claims.exp);
    const parseJwtUnsafe = (token) => {
        try {
            const [, base64Url] = token.split(".");
            if (!base64Url) {
                return null;
            }
            const padBase64 = (s) => s + "===".slice((s.length + 3) % 4);
            const base64 = padBase64(base64Url.replace(/-/g, "+").replace(/_/g, "/"));
            const jsonPayload = decodeURIComponent(atob(base64)
                .split("")
                .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
                .join(""));
            return JSON.parse(jsonPayload);
        }
        catch (_a) {
            return null;
        }
    };
    /**
     * Decodes a JWT payload and validates required claims (sub/jti/exp) exist.
     *
     * Important: This does NOT verify the JWT signature, issuer, or audience.
     * Treat decoded claims as untrusted and do not use this for authorization decisions.
     */
    const parseJwtClaims = (token) => {
        const claims = parseJwtUnsafe(token);
        return claims && isValidJwtClaims(claims) ? claims : null;
    };
    exports.parseJwtClaims = parseJwtClaims;
});
